import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccSubscriptionDisplayText = {
    recurringOneMonthBillingPeriodLabel: 'Pay monthly',
    recurringTwelveMonthsBillingPeriodLabel: 'Pay annually',
    recurringBillingPeriodLabel: 'Pay every ${billingPeriodInMonths} months',
    nonRecurringOneMonthBillingPeriodLabel: '1 month',
    nonRecurringBillingPeriodLabel: '${billingPeriodInMonths} months'
};
export const occSubscriptionDisplayTextValidator = Validator.object({
    recurringOneMonthBillingPeriodLabel: nonEmptyStringValidator,
    recurringTwelveMonthsBillingPeriodLabel: nonEmptyStringValidator,
    recurringBillingPeriodLabel: nonEmptyStringValidator,
    nonRecurringOneMonthBillingPeriodLabel: nonEmptyStringValidator,
    nonRecurringBillingPeriodLabel: nonEmptyStringValidator
});
